// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__S-R5r","content":"Popup_content__OsoxG","close":"Popup_close__b0UKg"};